import { trashTodoList } from '@erikdakoda/todo/ai-tools/trashTodoList';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(trashTodoList);
